<template lang="pug">
#app(ref='root' :ondragstart="isDraggable" :oncontextmenu="isDraggable" :onselectstart="isDraggable" data-app :class='[showMobileHeader ? "hidden_scroll" : ""]')
  //- POPUP
  template(v-if="showPopup")
    modal-view(@close-modal="closePopup()" @never-modal="neverShowPopup()")
      modal-content(:data='popupData' :flag='closeFlag' ref="slide")


  //- DEFAULT HEADER
  template(v-if="!noNavbar.includes($route.name) && !adminArea")
    state-header(:yScroll='yScroll' :showMobileHeader='showMobileHeader' @header-handler='toggleHeader' :storeModalView='storeModalView')
  //- MOBILE HEADER
  template(v-if="showMobileHeader")
    mobile-header(style='position: absolute;' @close-header='toggleHeader' :class='[showMobileHeader ? "" : "back-main"]')
  //- ADMIN HEADER
  template(v-if="adminArea")
    admin-header


  //- BANNER
  template(v-if="!noBanner.includes($route.name) && !adminArea")
    state-banner(style='position: relative;')

  router-view(:key='$route.fullPath' ref="router_view" style='position: relative;' :class='[showMobileHeader ? "back-main" : ""]' @get-modal='getModal' @store-modal='storeModal')
  //- @close-modal="closePopup()"


  //- FOOTER
  template(v-if="!noNavbar.includes($route.name) && !adminArea")
    state-footer
  //- TO TOP
  transition(name='fade')
    a#toTop(@click='toTop()' v-if='showToTop')
      span#toTopHover
</template>

<script>
import Header from './views/Guide/Header.vue';
import Footer from './views/Guide/Footer.vue';
import ModalView from './views/Guide/ModalView.vue';
import Content from './views/Guide/Content.vue';
import AdminHeader from './views/Admin/Header.vue';
import Banner from './views/Guide/Banner';
import MobileHeader from './views/Guide/MobileHeader';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
export default {
  components: {
    'state-header': Header,
    'mobile-header': MobileHeader,
    'admin-header': AdminHeader,
    'state-footer': Footer,
    'state-banner': Banner,
    'modal-view': ModalView,
    'modal-content': Content,
  },
  computed: {
    ...mapGetters(['lan', 'popup', 'userAccToken']),
    adminArea() {
      let name = this.$route.name;
      if (name) {
        let nameArr = name.split('-');
        if (nameArr[nameArr.length - 1] == 'admin') {
          return true;
        }
        return false;
      }
      return false;
    },
    connectDevice() {
      let res =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        );
      if (res) {
        return 'mobile';
      }
      return 'pc';
    },
    showPopup() {
      return (
        this.popup.length !== 0 && this.popupFlag && this.popupData.length !== 0
      );
    },
    showToTop() {
      let noToTop = ['privacy', 'terms', 'en-terms', 'en-privacy', 'contact-popup'];
      return (
        this.yScroll !== 0 &&
        !this.adminArea &&
        !this.storeModalView &&
        !noToTop.includes(this.$route.name)
      );
    },
    isDraggable() {
      // NOTE: 드래그 및 우측 클릭 가능 여부(admin page)
      if (this.adminArea) {
        return 'return true';
      }
      return 'return false';
    },
  },
  data() {
    return {
      popupFlag: false,
      popupNever: false,
      closeFlag: [],
      popupData: [],
      noNavbar: [
        'index',
        'terms',
        'en-terms',
        'privacy',
        'en-privacy',
        'admin',
        'content-admin',
        'not-found',
        'contact-popup',
      ],
      noBanner: [
        'index',
        'home',
        'en-home',
        'privacy',
        'en-privacy',
        'en-terms',
        'terms',
        'test',
        'admin',
        'content-admin',
        'not-found',
        'contact-popup'
      ],
      yScroll: 0,
      showMobileHeader: false,
      storeModalView: false,
    };
  },
  methods: {
    ...mapActions(['saveToken', 'editPopup', 'neverTimeReset']),
    pushPopup() {
      if (!this.popupNever && this.popupData.length == 0) {
        this.popup.forEach((e, i) => {
          if (
            (e.device == 'both' || e.device == this.connectDevice) &&
            e.neverShow
          ) {
            let temp = {
              idx: e.idx,
              file_src: e.img,
            };
            this.popupData.push(temp);
          }
        });
      }
    },
    closePopup() {
      this.$refs.slide.popData();
      let $_slideData = this.$refs.slide.slideData;
      if ($_slideData.length == 0) {
        this.popupFlag = false;
      }
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    toggleHeader() {
      this.showMobileHeader = !this.showMobileHeader;
      window.scrollTo({
        top: 0,
      });
    },
    neverShowPopup() {
      let $_activeIdx = this.$refs.slide.activeIdx;
      let $_slideData = this.$refs.slide.slideData;

      let now = new Date();
      let setTime = now.setHours(now.getHours() + 24);
      let payload = {
        idx: $_slideData[$_activeIdx].idx,
        neverTime: this.$moment(setTime).format('YYYY-MM-DD HH:mm'),
      };
      this.editPopup(payload);
      this.neverTimeChecker();
      this.getModal(false);
    },
    neverTimeChecker() {
      this.popup.forEach((e, i) => {
        if (e.neverTime !== '') {
          let now = new Date();
          if (now <= new Date(e.neverTime)) {
            // NOTE: 24시간 보지 않기 해당 중
            let payload = {
              idx: e.idx,
              neverShow: false,
            };
            this.editPopup(payload);
          } else {
            this.neverTimeReset(i);
          }
        }
      });
    },
    getModal(payload) {
      if (payload) {
        this.popupFlag = payload;
        this.pushPopup();
      } else {
        this.popupNever = true;
        this.closePopup();
      }
    },
    storeModal(payload) {
      this.storeModalView = payload;
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    Vue.nextTick(() => {
      window.onscroll = () => {
        this.yScroll = window.scrollY;
      };
    });
  },
};
</script>
<style>
@import './assets/css/common.css';
@import './assets/css/default.css';
@import './assets/css/news_board.css';
.none_scroll {
  overflow: hidden;
  margin-right: 16px;
}
#toTop {
  display: inline;
}
.hidden_scroll {
  overflow: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.back-main {
  visibility: hidden;
}
.modal-open {
  overflow: hidden;
  position: fixed;
}
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
